import React from 'react'
import { cn } from '@/lib/utils'

export interface TodayLineProps {
  x: number
  y1: number
  y2: number
  label?: string
  dashed?: boolean
}

/** Full-height today marker (red, solid) or status-date marker (primary, dashed). Spec B §8.3. */
const TodayLine: React.FC<TodayLineProps> = ({ x, y1, y2, label, dashed }) => (
  <g className="pointer-events-none">
    <line x1={x} x2={x} y1={y1} y2={y2} className={dashed ? 'stroke-primary' : 'stroke-destructive'} strokeWidth={1.5} strokeDasharray={dashed ? '4 3' : undefined} />
    {label && (
      <text x={x + 3} y={Math.max(9, y1 - 2)} className={cn('text-xs font-medium', dashed ? 'fill-primary' : 'fill-destructive')}>{label}</text>
    )}
  </g>
)

export default TodayLine
